import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Box, Typography, Container } from '@mui/material';
import { MotionContainer, varBounceIn } from '../components/animate';
import Page from '../components/Page';

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10)
}));

const HeDisable = () => {
  return (
    <RootStyle title="WiFi detected | ZetuPlay App">
      <Container>
        <MotionContainer initial="initial" open>
          <Box
            sx={{
              maxWidth: 480,
              margin: 'auto',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '100vh'
            }}
          >
            <motion.div variants={varBounceIn}>
              <Box component="img" src="/static/newlogo.png" sx={{ height: 200, mx: 'auto', mb: 4 }} />
            </motion.div>
            <motion.div variants={varBounceIn}>
              <Typography variant="h4" paragraph>
                WiFi detected.
              </Typography>
            </motion.div>
            <Typography sx={{ color: 'text.secondary', marginBottom: '24px' }}>
              Please switch to safaricom mobile data and refresh the page in order to sign in.
            </Typography>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
};

export default HeDisable;
